<script setup lang="ts">
import Button from '~/components/design-system/button.vue';
import FacebookIcon from '../../design-system/icons/FacebookIcon.vue';
import TwitterIcon from '../../design-system/icons/TwitterIcon.vue';
import InstagramIcon from '../../design-system/icons/InstagramIcon.vue';
import { socialLinks } from 'assets/data/config';

const siteStore = useSiteStore();
const { $trackEvent } = useNuxtApp();
const regionSocials = computed(() => socialLinks[siteStore.getRegionCode]);
</script>

<template>
  <div class="flex-center gap-2">
    <NuxtLink
      :to="regionSocials.instagram"
      target="_blank"
      @click="
        $trackEvent('NavigationEvent', 'GO_TO_SOCIAL_PAGE', {
          platform: 'Instagram',
        })
      "
    >
      <Button
        :aria-label="$t('instagram')"
        element-name="footer-social-link-for-instagram"
        type="secondary"
        shape="square"
      >
        <InstagramIcon class="mx-auto" />
      </Button>
    </NuxtLink>
    <NuxtLink
      :to="regionSocials.facebook"
      target="_blank"
      @click="
        $trackEvent('NavigationEvent', 'GO_TO_SOCIAL_PAGE', {
          platform: 'Facebook',
        })
      "
    >
      <Button
        :aria-label="$t('facebook')"
        element-name="footer-social-link-for-facebook"
        type="secondary"
        shape="square"
      >
        <FacebookIcon class="mx-auto" />
      </Button>
    </NuxtLink>
    <NuxtLink
      :to="regionSocials.x"
      target="_blank"
      @click="
        $trackEvent('NavigationEvent', 'GO_TO_SOCIAL_PAGE', {
          platform: 'Twitter',
        })
      "
    >
      <Button
        :aria-label="$t('twitter')"
        element-name="footer-social-link-for-twitter"
        type="secondary"
        shape="square"
      >
        <TwitterIcon class="mx-auto" />
      </Button>
    </NuxtLink>
  </div>
</template>

<style scoped lang="scss"></style>
